export const OrdersTableColumns = [
    { id: "order_number", labelEn: "Order #",     labelAr: "رقم الطلب",     align: "left",   sortable: true },
    { id: "customer",     labelEn: "Customer",    labelAr: "العميل",        align: "left",   sortable: false },
    { id: "items_count",  labelEn: "Items",       labelAr: "العناصر",       align: "center", sortable: false },
    { id: "payment",      labelEn: "Payment",     labelAr: "الدفع",         align: "center", sortable: false },
    { id: "shipping",     labelEn: "Shipping",    labelAr: "الشحن",         align: "center", sortable: false },
    { id: "grand_total",  labelEn: "Total",       labelAr: "الإجمالي",      align: "center", sortable: true },
    { id: "status",       labelEn: "Status",      labelAr: "الحالة",        align: "center", sortable: true },
    { id: "placed_at",    labelEn: "Placed",      labelAr: "تاريخ الطلب",   align: "center", sortable: true },
];
